import { ThunderDispatcher } from '@nu-art/thunderstorm-frontend/index';
export const dispatch_onAdvisorBoardUpdated = new ThunderDispatcher('__onAdvisorBoardUpdated');
export const dispatch_onAdvisorBoardTransitionEnd = new ThunderDispatcher('__onAdvisorBoardTransitionEnd');
//# sourceMappingURL=dispatchers.js.map